const data = {
  "analytics.reports.heading": "Reports",
  "analytics.report.modal.title": "Download Report",
  "analytics.report.send.email": "Send to Email",
  "analytics.report.processing": "Processing",
  "analytics.report.recent": "Recent Reports",
  "analytics.report.dateRange": "Select Date Range",
  "analytics.report.title.reportsdownload.tab": "Reports Download",
  "analytics.report.title.reports.tab": "Reports",
  "analytics.report.title.reportsdownload": "Previous Downloads",
  "analytics.report.id": "ID",
  "analytics.report.name": "Report Name",
  "analytics.report.createdAt": "Report Generated Date",
  "analytics.report.duration": "Report Duration (From : To)",
  "analytics.report.status": "Report Status",
  "analytics.report.download": "Download",
  "analytics.report.emptyState.message":
    "No previous reports are available to download here.",
};

export default data;
